<template>
  <div
    ref="dropdownRef"
    class="relative h-full"
    :class="[{ 'z-50': isDropdownShown }, { 'inline-flex': isMinimalistic }]"
  >
    <!-- Кнопка в стиле "три точки" -->
    <button
      v-if="isButtonLike"
      type="button"
      class="focus:outline-none"
      @click="toggleDropdown"
    >
      <SvgIcon name="dots-three-vertical" />
    </button>

    <!-- Обычный селект -->
    <div
      v-else
      class="dropdown-select__selected flex h-full max-w-[230px] cursor-pointer items-center justify-between text-[18px] text-[#4d4d4d] 2xl:max-w-[initial]"
      :class="{ 'bg-white-100': !isMinimalistic }"
      @click="toggleDropdown"
    >
      <span class="truncate">{{ selectedLabel || placeholder }}</span>
      <SvgIcon
        :name="isDropdownShown ? 'chevron-up' : 'chevron-down'"
        class="ml-2 min-w-[16px]"
      />
    </div>

    <!-- Выпадающий список -->
    <div
      v-if="isDropdownShown"
      class="custom-scrollbar absolute top-full flex max-h-[390px] w-auto flex-col overflow-x-hidden overflow-y-scroll rounded-b-lg bg-white-100 py-2 shadow-drop-2"
      :class="isMinimalistic || isButtonLike ? 'w-fit' : 'w-full'"
    >
      <div
        v-for="item in list"
        :key="item.id"
        class="cursor-pointer px-2 py-1 hover:bg-new-gray-lighter"
        @click="selectItem(item.id)"
      >
        {{ item.label || '' }}
      </div>
    </div>

    <!-- Ошибка -->
    <span v-if="error" class="text-smaller mt-1 text-ruby-red-100">
      {{ error }}
    </span>
  </div>
</template>

<script setup>
import { onClickOutside } from '@vueuse/core';
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: undefined,
  },
  list: {
    type: Array,
    default: () => [],
  },
  isMinimalistic: {
    type: Boolean,
    default: false,
  },
  isButtonLike: {
    type: Boolean,
    default: false,
  },
  isOnChangeLocalVarsResetEnabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: 'Выберите...',
  },
  error: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'on-select']);

const isDropdownShown = ref(false);
const dropdownRef = ref(null);

// Вычисляемое значение: текущая метка
const selectedLabel = computed(() => {
  if (props.modelValue === undefined || props.modelValue === null) return '';

  const selectedItem = props.list.find((item) => item.id === props.modelValue);
  return selectedItem ? selectedItem.label : '';
});

// Переключение видимости выпадающего списка
const toggleDropdown = () => {
  isDropdownShown.value = !isDropdownShown.value;
};

// Выбор элемента
const selectItem = (id) => {
  isDropdownShown.value = false;

  // Если нужно сбросить локальное состояние после выбора
  if (props.isOnChangeLocalVarsResetEnabled) {
    emit('update:modelValue', undefined);
    emit('on-select', undefined);
  } else {
    emit('update:modelValue', id);
    emit('on-select', id);
  }
};

// Закрытие по клику вне
onClickOutside(dropdownRef, () => {
  isDropdownShown.value = false;
});
</script>

<style lang="scss" scoped>
/* При необходимости можно добавить стили */
</style>
